import { gql } from "@apollo/client";

const INTERVIEW_SCHEDULING_SETTING_FIELDS = gql`
  fragment InterviewSchedulingSettingFields on InterviewSchedulingSetting {
    id
    ready
    eventStatus
    provider
    eventName
    durationMinutes
    timezone
    schedulingUrl
    videoProvider
    availability {
      weekday
      working
      dayStartsAt
      dayEndsAt
    }
  }
`;

const GET_INTERVIEW_SCHEDULING_SETTING = gql`
  ${INTERVIEW_SCHEDULING_SETTING_FIELDS}
  query InterviewSchedulingSetting {
    interviewSchedulingSetting {
      ...InterviewSchedulingSettingFields
    }
  }
`;

const GET_INTERVIEW_SCHEDULING_LOCATION_OPTIONS = gql`
  query InterviewSchedulingLocationOptions {
    interviewSchedulingLocationOptions {
      videoProvider
      connected
    }
  }
`;

const INTERVIEW_SCHEDULING_REQUEST_FIELDS = gql`
  fragment InterviewSchedulingRequestFields on InterviewSchedulingRequest {
    id
    status
    schedulingUrl
    scheduledStartAt
    scheduledEndAt
    expiresAt
    createdAt
    interviewerName
  }
`;

const GET_APPLICANT_INTERVIEW_SCHEDULING = gql`
  ${INTERVIEW_SCHEDULING_SETTING_FIELDS}
  ${INTERVIEW_SCHEDULING_REQUEST_FIELDS}
  query ApplicantInterviewScheduling($missionRoleApplicantId: ID!) {
    interviewSchedulingSetting {
      ...InterviewSchedulingSettingFields
    }
    interviewSchedulingRequests(missionRoleApplicantId: $missionRoleApplicantId) {
      ...InterviewSchedulingRequestFields
    }
  }
`;

export {
  GET_APPLICANT_INTERVIEW_SCHEDULING,
  INTERVIEW_SCHEDULING_REQUEST_FIELDS,
  GET_INTERVIEW_SCHEDULING_SETTING,
  INTERVIEW_SCHEDULING_SETTING_FIELDS,
  GET_INTERVIEW_SCHEDULING_LOCATION_OPTIONS,
};
